import Cache from 'services/utils/Cache';
import jsonCache from 'services/utils/jsonCache';
import withStorage from 'services/utils/withStorage';

export const JSONCache = jsonCache(Cache);
export const LocalStorageCache = withStorage(localStorage)(JSONCache);
export const SessionStorageCache = withStorage(sessionStorage)(JSONCache);
